import { render, staticRenderFns } from "./DialogMoverArmarios.vue?vue&type=template&id=f803ac2a"
import script from "./DialogMoverArmarios.vue?vue&type=script&lang=js"
export * from "./DialogMoverArmarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports